import moment from "moment";
import React, { useEffect, useState } from "react";
import { Backdrop, Dialog } from "@mui/material";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";

import ALoader from "../../../../common/a-loader";
import IconButtonWrapper from "../../../../common/form-fields-mui/IconButtonWrapper";
import AButton from "../../../../common/form-fields-mui/AButton";
import CommonInput from "../../../../common/formFeilds/input/commonInput";
import AAutoComplete from "../../../../common/form-fields-mui/AAutoComplete";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { updateRequest } from "views/pages/manage/edpOps/constant/common";

import {
  FORM_DEFAULT_VALUE,
  REPORT_TYPE,
  getAllActiveTerm,
  labelStyles,
  selectStyles,
  titleStyles,
} from "./constants";
import { getCourseIdDropdown } from "../manage-receipts/constants";
import { fetchAllPostPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../common/constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const MAX_BU_ALLOWED_IN_PAYLOAD = 10;

const DownloadReports = ({ open, setOpen, isCentralizedFlow, userId }) => {
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );

  const [isLoading, setIsLoading] = useState(true);
  const [isFetchingCourseIds, setIsFetchingCourseIds] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState({
    businessArea: [],
    term: [],
    courseId: [],
  });
  const [form, setForm] = useState(FORM_DEFAULT_VALUE);

  useEffect(() => {
    fetchBuAndTerm();

    async function fetchBuAndTerm() {
      const response = await getAllActiveTerm();

      // fetch bu & term dropdown values
      setDropdownOptions((prev) => ({
        ...prev,
        term: response,
        businessArea: masterDropdowns?.allBusinessAreaList,
      }));
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (form.businessAreaList.length && form.termValueList.length) {
      updateCourseIdOptions();
      formHandler([], "courseIdList");
    }

    async function updateCourseIdOptions() {
      setIsFetchingCourseIds(true);
      // fetch courseId when changed bu/term
      const res = await getCourseIdDropdown({
        businessAreaIds: form.businessAreaList.map((bu) => bu.businessAreaId),
        academicTermIds: form.termValueList.map((term) => term.id),
      });
      setDropdownOptions((prev) => ({ ...prev, courseId: res }));
      setIsFetchingCourseIds(false);
    }
  }, [form?.businessAreaList, form?.termValueList]);

  const formHandler = (value, key) => {
    setForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const resetHandler = () => {
    setForm(FORM_DEFAULT_VALUE);
  };

  const downloadReport = async () => {
    setIsLoading(true);

    const payload = {
      ...updateRequest(form),
      //   reportType: form.reportType.value,
      collectionFromDate: moment(form?.collectionFromDate).startOf("day"),
      collectionToDate: moment(form?.collectionToDate).endOf("day"),
      createdBy: userId,
    };

    try {
      const resp = await fetchAllPostPromisedData(
        `${endpoint.downloadReports}`,
        payload
      );

      if (resp?.code === 200) {
        const { key } = resp?.data;

        const templateUrl = await fetchAllPostPromisedData(
          `${endpoint.fetchS3Url.getDownloadUrl}?key=${key}`,
          {}
        );
        if (templateUrl?.code === 200 && templateUrl?.data) {
          window.open(`${templateUrl?.data?.url}`);
          resetHandler();
          setOpen(false);
        } else {
          failureToast("Something went wrong! Please try after sometime.");
        }
      }
    } catch (err) {
      console.log(err);
    }

    setIsLoading(false);
  };

  const isDownloadDisabled =
    !form.reportType ||
    !form.collectionFromDate ||
    !form.collectionToDate ||
    (!isCentralizedFlow && !form.businessAreaList.length);

  return (
    <Dialog
      aria-label="Dialog to download reports"
      open={open}
      PaperProps={{
        sx: {
          minHeight: "280px",
          minWidth: "800px",
          maxWidth: "unset",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
    >
      <div
        style={titleStyles}
        className="d-flex justify-content-between align-items-center"
      >
        <div>Select report details</div>
        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={() => {
            setOpen(false);
            resetHandler();
          }}
          disabled={isLoading}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <>
        <div>
          <AAutoComplete
            label="Report type"
            placeholder="Select report type"
            items={REPORT_TYPE}
            labelStyle={labelStyles}
            isMulti={false}
            currentValue={form?.reportType}
            handleChange={(val) => {
              formHandler(val, "reportType");
            }}
            aria-label="Select report type from the dropdown"
            //   tabIndex="1"
            style={{ control: { height: "40px", borderRadius: "4px" } }}
          />
        </div>

        <Row className="justify-content-between my-3 flex-nowrap">
          <Col>
            <label
              style={labelStyles}
              htmlFor="Select start Collection date for which report has to be generated from the datepicker"
            >
              Collection date from
            </label>
            <CommonInput
              type="datePicker"
              placeHolder="Select"
              onChange={(val) => {
                formHandler(val, "collectionFromDate");

                const oneMonthLater = moment.min([
                  new moment(val)?.add(1, "month"),
                  moment().startOf("day"),
                ]);
                formHandler(oneMonthLater, "collectionToDate");
              }}
              defaultValue={form?.collectionFromDate}
              maxDate={moment().startOf("day")}
              // tabIndex="2"
            />
          </Col>

          <Col>
            <label
              style={labelStyles}
              htmlFor="Select Collection date until which report has to be generated. This date can 30 days apart from the initial selected date."
            >
              Collection date to
            </label>
            <CommonInput
              type="datePicker"
              placeHolder="Select"
              onChange={(val) => formHandler(val, "collectionToDate")}
              defaultValue={form?.collectionToDate}
              minDate={new moment(form?.collectionFromDate)}
              maxDate={
                form?.collectionFromDate
                  ? moment.min([
                      new moment(form?.collectionFromDate)?.add(1, "month"),
                      moment().startOf("day"),
                    ])
                  : moment().startOf("day")
              }
              // tabIndex="3"
            />
          </Col>

          <Col>
            <AAutoComplete
              label="Business Area"
              items={dropdownOptions.businessArea}
              labelStyle={labelStyles}
              isMulti={true}
              isShowCount
              currentValue={form?.businessAreaList}
              handleChange={(val) => {
                if (val.length > MAX_BU_ALLOWED_IN_PAYLOAD)
                  formHandler(
                    val.slice(0, MAX_BU_ALLOWED_IN_PAYLOAD),
                    "businessAreaList"
                  );
                else formHandler(val, "businessAreaList");
              }}
              style={selectStyles}
              aria-label="Select business area from the dropdown. You can choose more than one."
              // tabIndex="4"
            />

            <small style={{ color: "#7a7272" }}>
              * <span style={{ fontSize: "10px" }}>Max 10 can be selected</span>
            </small>
          </Col>

          <Col>
            <AAutoComplete
              label="Term"
              items={dropdownOptions.term}
              labelStyle={labelStyles}
              isMulti={true}
              isShowCount
              currentValue={form?.termValueList}
              handleChange={(val) => {
                formHandler(val, "termValueList");
              }}
              style={selectStyles}
              aria-label="Select terms from the dropdown. You can choose more than one."
              // tabIndex="5"
            />
          </Col>

          <Col>
            <AAutoComplete
              label="Course ID"
              items={dropdownOptions.courseId}
              labelStyle={labelStyles}
              isMulti={true}
              isShowCount
              isLoading={isFetchingCourseIds}
              currentValue={form?.courseIdList}
              handleChange={(val) => {
                formHandler(val, "courseIdList");
              }}
              style={selectStyles}
              aria-label="Select course Id. You can choose more than one."
              // tabIndex="6"
            />
          </Col>
        </Row>

        {isLoading && (
          <Backdrop
            sx={(theme) => ({
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1300,
            })}
            open={isLoading}
          >
            <ALoader />
          </Backdrop>
        )}
      </>

      <div className="mt-auto">
        <AButton
          children={"Download report"}
          variant="primary_filled"
          className="no-ml-btn"
          disabled={isLoading || isDownloadDisabled}
          onClick={downloadReport}
          aria-label="Click to generate the report"
          updatedStyle={{
            width: "270px",
          }}
        />

        <AButton
          children={"Reset"}
          variant="outline"
          onClick={resetHandler}
          aria-label="Reset the form"
          disabled={isLoading}
          updatedStyle={{
            width: "270px",
            border: "1px solid #CBCBCB",
            color: "#000",
            fontFamily: "Gilroy-Medium",
          }}
        />
      </div>
    </Dialog>
  );
};

export default DownloadReports;
